import { render } from "./staffAdd.vue?vue&type=template&id=3156d0ec&scoped=true"
import script from "./staffAdd.vue?vue&type=script&lang=js"
export * from "./staffAdd.vue?vue&type=script&lang=js"

import "./staffAdd.vue?vue&type=style&index=0&id=3156d0ec&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3156d0ec"]])

export default __exports__